// extracted by mini-css-extract-plugin
export default {"image":"background__image__MMSm4","color":"background__color__uujAe","video":"background__video__sot8B","videoEnabled":"background__videoEnabled__kKBR_"};